import React from 'react';
import { AtSign } from 'lucide-react';

export default function DiscordUsernameField({ value, onChange, valid }) {
  const showError = value.trim().length > 0 && !valid;
  return (
    <div className="mt-6" data-testid="vip-discord-field">
      <label htmlFor="vip-discord-input" className="block text-xs uppercase tracking-[0.3em] text-white/50 font-mono mb-2">
        Discord username <span className="text-amber-300">*required</span>
      </label>
      <div className="relative">
        <AtSign className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-white/30" />
        <input
          id="vip-discord-input"
          data-testid="vip-discord-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="yourname"
          autoComplete="off"
          className={`w-full pl-11 pr-4 py-2.5 rounded-full bg-white/[0.04] border outline-none text-white placeholder-white/30 text-sm ${showError ? 'border-red-400/60' : 'border-white/10 focus:border-brand'}`}
        />
      </div>
      <p data-testid="vip-discord-help" className={`mt-2 text-xs ${showError ? 'text-red-300' : 'text-white/40'}`}>
        {showError ? 'Use your Discord username (2–32 letters, numbers, _ or .), not your display name.' : 'So we can find you in our Discord and give you your roles.'}
      </p>
    </div>
  );
}
